export const COOKIES = {
  COOKIE_LEGAL_DISCLAIMER: 'legalDisclaimerBanner'
};
